import { App } from '@gin-betting/core';
import { OrderedSet } from 'immutable';

import { useToggler } from 'hooks';
import { DEFAULT_CONFIG_LIST_SIZE } from '../../constants';
import { useFeaturedConfigs } from '../../hooks';
import type { FeaturedConfig } from '../../types';

interface Output {
    featuredConfigs: OrderedSet<FeaturedConfig>;
    toggleExpand: VoidFunction;
    isExpanded: boolean;
    isShowExpandButton: boolean;
    fetchStatus: App.FetchStatus;
}

const useFeaturedTournaments = (): Output => {
    const { fetchStatus, featuredConfigs } = useFeaturedConfigs();

    const [isExpanded, toggleExpand] = useToggler(false);

    const visibleConfigs = isExpanded
        ? featuredConfigs
        : featuredConfigs.slice(0, DEFAULT_CONFIG_LIST_SIZE);

    const isShowExpandButton = featuredConfigs.size > DEFAULT_CONFIG_LIST_SIZE;

    return {
        featuredConfigs: visibleConfigs,
        toggleExpand,
        isExpanded,
        isShowExpandButton,
        fetchStatus,
    };
};

export default useFeaturedTournaments;
